export default __webpack_public_path__ + "static/media/germlin.52ce2680.png";